// extracted by mini-css-extract-plugin
export default {"imageContainer":"VideoSection_imageContainer__jZUxN","coverImage":"VideoSection_coverImage__CFkFH","showImageButton":"VideoSection_showImageButton__RiRKr"};